import { Scale, FileText, File, Package, FolderOpen, LifeBuoy } from 'lucide-react';

export default function PackageSection() {
    const features = [
        {
            icon: Scale,
            title: "Attorney-Reviewed Software",
            description: "Prepare USCIS forms correctly with easy, step-by-step process and alerts if there's a problem"
        },
        {
            icon: FileText,
            title: "Official USCIS Forms",
            description: "Perfectly prepared documents on the latest edition of USCIS forms"
        },
        {
            icon: File,
            title: "Personal Filing Instructions",
            description: "Directions on supporting documents and how to organize your application"
        },
        {
            icon: Package,
            title: "Printing & Shipping",
            description: "Digital download on all orders and optional print and ship available"
        },
        {
            icon: FolderOpen,
            title: "Sample Documents",
            description: "Example cover letters, affidavits and how-to information for your situation"
        },
        {
            icon: LifeBuoy,
            title: "Customer Support",
            description: "Live, knowledgeable customer support at your fingertips"
        }
    ];

    return (
        <section className="py-16 px-4 bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-blue-600 mb-12">
                    Every Package Includes
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <div
                                key={index}
                                className="bg-white border-2 border-blue-400 rounded-lg p-8 flex flex-col items-center text-center hover:shadow-lg transition-shadow"
                            >
                                <div className="mb-6">
                                    <Icon className="w-16 h-16 text-blue-600" strokeWidth={1.5} />
                                </div>
                                <h3 className="text-xl font-bold text-blue-600 mb-4">
                                    {feature.title}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {feature.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}